import { render } from "./HeroiconsSolidNewspaper.vue?vue&type=template&id=1f4d7d20"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidNewspaper.vue"]])

export default __exports__